/* tslint:disable */
/* eslint-disable */
export enum CompanyType {
  Construction = 'Construction',
  Consulting = 'Consulting',
  ConstructionAndConsulting = 'ConstructionAndConsulting'
}
